export const FEE = `FEE`;

export const GET_LIST_LOV_DATA = `${FEE}/GET_LIST_LOV_DATA`;
export const SET_LIST_LOV_DATA = `${FEE}/SET_LIST_LOV_DATA`;

export const GET_RECEIPT_LIST_DATA = `${FEE}/GET_RECEIPT_LIST_DATA`;
export const SET_RECEIPT_LIST_DATA = `${FEE}/SET_RECEIPT_LIST_DATA`;

export const GET_RECEIPT_DETAIL_DATA = `${FEE}/GET_RECEIPT_DETAIL_DATA`;
export const SET_RECEIPT_DETAIL_DATA = `${FEE}/SET_RECEIPT_DETAIL_DATA`;

export const GET_VALID_AGENT_DATA = `${FEE}/GET_VALID_AGENT_DATA`;
export const GET_DEBT_BY_POL_APP_DATA = `${FEE}/GET_DEBT_BY_POL_APP_DATA`;
export const GET_DEBT_BY_POL_FOR_RENEWAL_PREM_DATA = `${FEE}/GET_DEBT_BY_POL_FOR_RENEWAL_PREM_DATA`;

export const SET_RECEIPT_DATA = `${FEE}/SET_RECEIPT_DATA`;
export const CANCEL_RECEIPT_DATA = `${FEE}/CANCEL_RECEIPT_DATA`;
